import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MagazinHero } from '../components/magazin/MagazinHero';
import { MagazinProducts } from '../components/magazin/MagazinProducts';
import { MagazinConsultation } from '../components/magazin/MagazinConsultation';
export function MagazinPage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2389">
      <Header data-id="element-2390" />
      <main data-id="element-2391">
        <MagazinHero data-id="element-2392" />
        <MagazinProducts data-id="element-2393" />
        <MagazinConsultation data-id="element-2394" />
      </main>
      <Footer data-id="element-2395" />
    </div>;
}